const SELECTOR = '[data-ch-memories-loader]:not([data-ch-memories-loaded])';
const BACKGROUND_SELECTOR = '.ch-polaroid-line__background-media img';
const ROOT_MARGIN = '2600px 0px';
const BACKGROUND_TIMEOUT = 1200;

function normalizeSource(source) {
  return source.startsWith('//') ? `${window.location.protocol}${source}` : source;
}

function moduleSources(root) {
  try {
    return JSON.parse(root.dataset.chMemoriesModuleSrcs || '[]');
  } catch {
    return [];
  }
}

function waitForImage(image) {
  if (!(image instanceof HTMLImageElement)) return Promise.resolve();

  image.loading = 'eager';
  image.fetchPriority = 'low';

  if (image.complete) return image.decode?.().catch(() => {}) || Promise.resolve();

  return new Promise((resolve) => {
    let timeout;
    const finish = () => {
      clearTimeout(timeout);
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
      resolve();
    };

    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
    timeout = setTimeout(finish, BACKGROUND_TIMEOUT);
  });
}

async function warmBackground(root) {
  await waitForImage(root.querySelector(BACKGROUND_SELECTOR));
}

async function loadMemories(root) {
  if (!(root instanceof Element) || root.dataset.chMemoriesLoading) return;

  root.dataset.chMemoriesLoading = 'true';

  try {
    await warmBackground(root);

    for (const source of moduleSources(root)) {
      await import(normalizeSource(source));
    }

    root.dataset.chMemoriesLoaded = 'true';
    root.dispatchEvent(new CustomEvent('ch:memories-loaded'));
  } catch (error) {
    root.dataset.chMemoriesLoading = 'error';
    console.error('Could not initialise Memories Captured', error);
  }
}

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            loadMemories(entry.target);
          });
        },
        { rootMargin: ROOT_MARGIN }
      )
    : null;

function hydrateMemories(root = document) {
  const sections = [];

  if (root instanceof Element && root.matches(SELECTOR)) sections.push(root);
  root.querySelectorAll?.(SELECTOR).forEach((section) => sections.push(section));

  sections.forEach((section) => {
    if (observer) observer.observe(section);
    else loadMemories(section);
  });
}

hydrateMemories();

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  hydrateMemories(event.target);
});
